import React from 'react';
import cn from "classnames";
import useTrans from "components/hooks/useTrans";
import { IPricingTier } from "pages/pricing";
import Link from "components/base/Link";

type Props = {
    active?: boolean;
    quantity?: number;
    onClick?: any;
};

export default function UpgradeBar(props: Props) {
    const { active, quantity } = props;
    const { t } = useTrans();

    const upgradeBarCn = cn(
        "bg-primary-400 text-white text-center rounded-bl-xl px-6 py-2 rounded-br-xl text-sm transition-all lg:text-lg lg:text-center lg:font-thin",
        active ? "" : "transform -translate-y-full -z-10",
        "lg:text-lg font-light lg:font-normal",
    );

    return (
        <div className={upgradeBarCn}>
            {t('looksLikeYouHaveMoreThanContacts', { quantity: quantity })}
            &nbsp;
            <Link to={'/demo-request'}>
                <span className={"text-white cursor-pointer font-normal lg:font-semibold lg:underline"}>
                    {t('talkToSales')}
                </span>
            </Link>
        </div>
    );
}